import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { partial } from 'lodash';
import PropTypes from 'prop-types';

import {
  acknowledgeAnnouncement,
  updateTeamAnnouncement,
} from 'actions/teamEmails';

import { MessageDrawerListHeader } from 'features/messengerv2/MessageDrawerList';

import Box from 'components/Box/index';
import Button from 'components/clickables/Button';
import Text from 'components/Text/index';

import cxHelpers from 'util/className';
import { moment } from 'util/dateTime';
import { toI18n } from 'util/i18n';

import PinnedToggle from '../PinnedToggle';

import Attachment from './Attachment';
import CountOfTotalButton from './CountOfTotalButton';

@connect(() => ({}), { acknowledgeAnnouncement, updateTeamAnnouncement })
@cxHelpers('EmailItem')
export default class EmailItem extends PureComponent {
  static propTypes = {
    announcement: PropTypes.instanceOf(Map).isRequired,
    onReturn: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onUnpin: PropTypes.func.isRequired,
    showAnnouncementsV2: PropTypes.bool.isRequired,
    acknowledgeAnnouncement: PropTypes.func.isRequired,
    updateTeamAnnouncement: PropTypes.func.isRequired,
    showSummary: PropTypes.func,
    isCurrentUserManager: PropTypes.bool.isRequired,
  };

  state = {
    sent: false,
  };

  handleReturn = () => {
    this.props.onReturn();
  };

  handleUnpinTeamAnnouncement = () =>
    this.props.onUnpin(this.props.announcement);

  handleAcknowledge = () => {
    if (this.state.sent) {
      return;
    }

    this.setState({ sent: true });

    setTimeout(() => {
      this.props.acknowledgeAnnouncement(this.props.announcement.get('id'));
    }, 3000);
  };

  handlePin = () =>
    this.props.updateTeamAnnouncement(this.props.announcement.get('id'), {
      pinned: !this.props.announcement.get('pinned'),
    });

  renderBody() {
    const {
      body,
      audience,
      created_at: createdAt,
      location_name: locationName,
    } = this.props.announcement.toJS();

    const mCreatedAt = moment(createdAt, 'MM/DD/YYYY HH:mm');
    const sentTo = toI18n('message_drawer.team_emails.sent_to', {
      props: {
        audience: toI18n(`message_drawer.team_emails.audiences.${audience}`),
        location: locationName,
        date: mCreatedAt.format('ddd, D MMM'),
        time: mCreatedAt.format('h:mm A'),
      },
    });
    const showAcknowledgeCount =
      this.props.announcement.get('requires_acknowledgment') &&
      this.props.announcement.get('recipients_count');

    return (
      <Box h="100%">
        {this.props.showAnnouncementsV2 &&
          (this.props.isCurrentUserManager || showAcknowledgeCount) && (
            <Box bb ph={32} row spacebetween pv={12}>
              <Box vcenter>
                {showAcknowledgeCount && (
                  <CountOfTotalButton
                    total={this.props.announcement.get('recipients_count')}
                    count={this.props.announcement.get('acknowledged_count')}
                    onClick={partial(
                      this.props.showSummary,
                      this.props.announcement
                    )}
                  />
                )}
              </Box>
              {this.props.isCurrentUserManager && (
                <Box vcenter>
                  <PinnedToggle
                    onClick={this.handlePin}
                    pinned={this.props.announcement.get('pinned')}
                  />
                </Box>
              )}
            </Box>
          )}
        <Box phxl pvm>
          <div>
            <Text asHTML black fs14 preWrap>
              {body}
            </Text>
          </div>

          <div className="pts mb32">
            <Text grayDark fs12 fw400>
              {sentTo}
            </Text>
          </div>

          {this.props.showAnnouncementsV2 &&
            this.props.announcement
              .get('attachments')
              .map(file => (
                <Attachment
                  key={file.get('origin_url')}
                  fileName={file.get('file_name')}
                  href={file.get('origin_url')}
                />
              ))}

          {this.props.announcement.get('needs_acknowledgment') && (
            <Box
              z={2}
              absolute
              bottom={32}
              left={0}
              ph={30}
              borderbox
              tcenter
              w="100%"
            >
              <Button
                fullWidth
                theme="primary-purple"
                onClick={this.handleAcknowledge}
                className={this.cxEl('cta')}
                i18n={`message_drawer.team_announcements.${
                  this.state.sent ? 'sent' : 'receipt'
                }`}
              />
            </Box>
          )}
        </Box>
      </Box>
    );
  }

  renderUnpinCTA() {
    if (
      this.props.showAnnouncementsV2 ||
      !this.props.announcement.get('pinned') ||
      !this.props.announcement.get('team_announcement_id')
    ) {
      return null;
    }

    return (
      <Box phxl pbm>
        <Button
          className={this.cxEl('unpin_cta')}
          i18n="message_drawer.team_emails.unpin_cta"
          onClick={this.handleUnpinTeamAnnouncement}
          theme="primary-blue"
          fullWidth
        />
      </Box>
    );
  }

  render() {
    return (
      <Box className={this.cx()} height="100%">
        <MessageDrawerListHeader
          title={this.props.announcement.get('subject')}
          handleReturn={this.handleReturn}
          handleClose={this.props.onClose}
        />
        {this.renderBody()}
        {this.renderUnpinCTA()}
      </Box>
    );
  }
}
